var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoInternetAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 119,
    viewBox: "0 0 117 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.437 63.1067V110.75H8V63.1092H29.1585V64.6092H9.5V109.25H106.937V64.6117L41.5835 64.831L41.5785 63.331L108.437 63.1067Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.75 28C37.75 29.1046 36.8546 30 35.75 30C34.6454 30 33.75 29.1046 33.75 28C33.75 26.8954 34.6454 26 35.75 26C36.8546 26 37.75 26.8954 37.75 28Z",
    fill: "#959595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.75 33.75C34.75 33.3358 35.0858 33 35.5 33V33C35.9142 33 36.25 33.3358 36.25 33.75V64.25C36.25 64.6642 35.9142 65 35.5 65V65C35.0858 65 34.75 64.6642 34.75 64.25V33.75Z",
    fill: "#959595"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.75 81H106.75V109H21.75V81Z",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.377 91.3663C31.377 92.5914 30.3839 93.5846 29.1587 93.5846C27.9336 93.5846 26.9404 92.5914 26.9404 91.3663C26.9404 90.1411 27.9336 89.1479 29.1587 89.1479C30.3839 89.1479 31.377 90.1411 31.377 91.3663Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2501 91.3663C40.2501 92.5914 39.2569 93.5846 38.0318 93.5846C36.8066 93.5846 35.8135 92.5914 35.8135 91.3663C35.8135 90.1411 36.8066 89.1479 38.0318 89.1479C39.2569 89.1479 40.2501 90.1411 40.2501 91.3663Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1241 91.3663C49.1241 92.5914 48.1309 93.5846 46.9058 93.5846C45.6807 93.5846 44.6875 92.5914 44.6875 91.3663C44.6875 90.1411 45.6807 89.1479 46.9058 89.1479C48.1309 89.1479 49.1241 90.1411 49.1241 91.3663Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M48.75 9.212L47.538 8L24.75 30.788L25.962 32L35.118 22.844C35.9981 22.5443 36.9435 22.4912 37.8516 22.6907C38.7598 22.8901 39.5959 23.3345 40.2694 23.9754L41.4814 22.7634C40.2926 21.6251 38.7326 20.9542 37.0886 20.8743L39.9926 17.9703C41.4579 18.4567 42.795 19.2667 43.9046 20.3403L45.1157 19.1283C44.0209 18.0652 42.7333 17.2207 41.322 16.64L43.8909 14.0711C45.2285 14.7668 46.457 15.6548 47.5371 16.7069L48.75 15.494V15.4923C47.6759 14.4422 46.4684 13.5379 45.1586 12.8026L48.75 9.212ZM35.6186 17.4954L37.3689 15.7451C37.1614 15.734 36.9583 15.7143 36.75 15.7143C33.6178 15.7142 30.6105 16.9431 28.3749 19.1369L29.5869 20.348C31.2235 18.7517 33.3463 17.7477 35.6186 17.4954ZM36.75 12.2857C37.9727 12.2914 39.1904 12.4425 40.3774 12.7357L41.7857 11.3283C38.8348 10.4195 35.6929 10.3267 32.6935 11.0597C29.6941 11.7927 26.9492 13.3241 24.75 15.4914V15.5111L25.9534 16.7146C28.8295 13.8754 32.7086 12.2842 36.75 12.2857Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInternetAccess);
export default __webpack_public_path__ + "static/media/noInternetAccess.31d069bb07984309e0a0f9f6a6b2f7a0.svg";
export { ForwardRef as ReactComponent };